import { useState } from 'react';
import { Row, Col, Typography } from 'antd';
import Data from '../../../CustomText/data';
import { convertCentsIntoDollar, formatDate } from '../../../../helpers/genericHelper';
import { UpOutlined, DownOutlined, DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import API from '../../../../services/API';

const { Text, Title } = Typography;
export default function StatementView({ statement }) {

  const [expandInfo, setExpandInfo] = useState(false);
  const [loading, setLoading] = useState(false);

  const downloadStatement = async () => {
    setLoading(true);
    try {
    const statementBlob = await API.getProductStatementFile({ type: 'creditCard', statementId: statement?.statementId });
      var file = new Blob([statementBlob], {type: 'application/pdf'});
      const url = window.URL.createObjectURL(file);
      window.open(url)
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return <>
  <Row>
    <Col span="4" offset={1}>
      <Data title="Statement Date">
        <Title level={5}>{(statement?.statementData?.statementDate)}</Title>
      </Data>
    </Col>
    <Col span="4">
      <Data title="Payment Due Date">
        <Title level={5}>{(statement?.statementData?.paymentDueDate)}</Title>
      </Data>
    </Col>
    <Col span="4">
      <Data title="Last Payment Date">
        <Title level={5}>{(statement?.statementData?.lastPaymentDate)} </Title>
      </Data>
    </Col>
    <Col span="4">
      <Data title="Statement ID" value={statement?.statementId} copyable/>
      { !loading && <DownloadOutlined onClick={downloadStatement} /> }
      { loading && <LoadingOutlined /> }
    </Col>
    <Col span="4">
      { statement?.isOverdue && <Data isTag tagColor="error" value="Overdue"/> }
      { statement?.overdueMoreThan30Days && <Data isTag tagColor="error" value="Overdue More Than 30 Days"/> }
    </Col>
  </Row>
  <Row>
    <Col span="4" offset={1}>
      <Data title="Previous Balance">
        <Title level={3}>{convertCentsIntoDollar(statement?.statementData?.previousBalance)}</Title>
      </Data>
    </Col>
    <Col span="4" >
      <Data title="Statement Balance">
        <Title level={3}>{convertCentsIntoDollar(statement?.statementData?.statementBalance)}</Title>
      </Data>
    </Col>
    <Col span="4">
      <Data title="Amount Past Due">
        <Title level={3}>{convertCentsIntoDollar(statement?.amountPastDue)} </Title>
      </Data>
    </Col>
    <Col span="4">
      <Data title="Payments & Credits" >
        <Title level={5}>{convertCentsIntoDollar(statement?.paymentsAndCreditAmount)}</Title>
      </Data>
    </Col>
    <Col span="4">
      <Data title="Purchases & Debits" >
        <Title level={5}>{convertCentsIntoDollar(statement?.purchasesAndDebitAmount)}</Title>
      </Data>
    </Col>
  </Row>
  <Row>&nbsp;</Row>
  { expandInfo && <><Row>
    <Col span="10" offset={1}>
        <Title level={5} underline>Purchases & Debits</Title>
        {
          statement?.purchasesAndDebits && statement?.purchasesAndDebits?.sort((a, b) => new Date(b.statementEntityInstant) - new Date(a.statementEntityInstant)).map((purchase, index) => (
            <Row key={index}>
              <Col span="6">
                <Data title="Date">
                  {formatDate(purchase?.statementEntityInstant)}
                </Data>
              </Col>
              <Col span="6">
                <Data title="Description">
                  {purchase?.descriptor}
                </Data>
              </Col>
              <Col span="4">
                <Data title="Amount">
                  {convertCentsIntoDollar(purchase?.amount)}
                </Data>
              </Col>
            </Row>
          ))
        }
        { statement?.purchasesAndDebits && statement?.purchasesAndDebits.length === 0 && <Text strong>- No Purchases & Debits -</Text> }
    </Col>
    <Col span="10" >
        <Title level={5} underline>Payment & Credits</Title>
        {
          statement?.paymentsAndCredits && statement?.paymentsAndCredits.sort((a, b) => new Date(b.statementEntityInstant) - new Date(a.statementEntityInstant)).map((payment, index) => (
            <Row key={index}>
              <Col span="6">
                <Data title="Date">
                  {formatDate(payment?.statementEntityInstant)}
                </Data>
              </Col>
              <Col span="6">
                <Data title="Description">
                  {payment?.descriptor}
                </Data>
              </Col>
              <Col span="4">
                <Data title="Amount">
                  {convertCentsIntoDollar(payment?.amount)}
                </Data>
              </Col>
            </Row>
          ))
        }
        { statement?.paymentsAndCredits && statement?.paymentsAndCredits.length === 0 && <Text strong>- No Payments & Credits -</Text> }
    </Col>
  </Row>
  <Row>&nbsp;</Row>
  </> }
  { !expandInfo && <Row><Col span={2} offset={10}><Text underline onClick={()=> setExpandInfo(true) }><DownOutlined /> Expand Details <DownOutlined /></Text></Col></Row>}
  { expandInfo && <Row><Col span={2} offset={10}><Text underline onClick={()=> setExpandInfo(false) }><UpOutlined /> Collapse Details <UpOutlined /></Text></Col></Row>}
  
</>
}